import { useTranslation } from "react-i18next";
const TableHeader = (props) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {props.header.map((item, index) => (
          <th style={{ textAlign: item.align }}>{t(item.title)}</th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
